import './MainHeader.css';

type MainHeaderProps = {
  isSidebarOpen: boolean;
  isAuthenticated: boolean;
  children: React.ReactNode;
};

export default function MainHeader({ isSidebarOpen, isAuthenticated, children }: MainHeaderProps) {
  return (
    <header className={`main-header ${!isSidebarOpen ? 'sidebar-closed' : ''} ${isAuthenticated ? '' : 'full-width'}`}>
      {children}
    </header>
  );
}
